export default __webpack_public_path__ + "static/mesh-logo-square-f2f179873a3365311dccb24e69ca076d.svg";